<template>
  <div class="flex flex-col gap-5 justify-center items-center py-3 px-5">
    <div class="text-center text-black flex flex-col">
      <h1 class="text-[26px] font-bold">{{ getErrorMessage().msg }}</h1>
      <div class="text-xl">{{ getErrorMessage().description }}</div>
    </div>
    <div>
      <div class="grid grid-cols-2 gap-2">
        <div class="flex flex-col items-center gap-3">
          <img :src="redCross" class="w-6 h-6" />
          <div
            class="flex justify-center items-center w-full h-full bg-black rounded shadow-md"
          >
            <img :src="photo" class="h-full object-contain rounded-none" />
          </div>
        </div>
        <div class="flex flex-col items-center gap-3">
          <img :src="ok" class="w-6 h-6" />
          <div
            class="relative flex h-full items-center bg-black m-auto rounded shadow-md"
          >
            <span
              class="w-fit absolute top-1.5 right-0 left-0 mx-auto bg-white px-2.5 text-center text-xl font-bold z-50"
            >
              {{ $t('result.example') }}
            </span>
            <img
              :src="isHybrid ? goodExample_hybrid : goodExample"
              class="h-full rounded"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col items-center gap-5">
      <ButtonComponent
        :disabled="disableButton"
        buttonName="result.retake"
        @click="handleRetakePhoto"
      />
      <ButtonComponent
        buttonClass="underline text-base font-normal text-black"
        buttonName="instruction.watch"
        @click="goHome()"
      />
    </div>
  </div>

  <!-- open instructions popup -->
  <Instructions
    :isHybrid="isHybrid"
    :openInstruction="openInstructions"
    @close="toggleInstruction"
  />
</template>

<script setup>
import ok from '@/assets/icons/ok.svg'
import redCross from '@/assets/icons/redCross.svg'
import goodExample from '@/assets/images/new-good-example.jpg'
import goodExample_hybrid from '@/assets/images/hybrid_qr.png'
import { events } from '@/utils/events'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import ButtonComponent from '../ButtonComponent.vue'
import Instructions from '../Instructions.vue'

const { t } = useI18n()

const props = defineProps({
  codeStatus: {
    type: String,
    required: true
  },
  imageQuality: Array,
  photo: String,
  isHybrid: Boolean
})

const disableButton = ref(false)
const openInstructions = ref(false)

const getQualityErrorMessage = computed(() => {
  const too_small = props.imageQuality.includes('too_small')
  const too_big = props.imageQuality.includes('too_big')
  const blurry = props.imageQuality.includes('blurry')
  if (too_small) {
    return {
      msg: t('result.qr_too_small.msg'),
      description: t('result.qr_too_small.description')
    }
  } else if (too_big) {
    return {
      msg: t('result.qr_too_large.msg'),
      description: t('result.qr_too_large.description')
    }
  } else if (blurry) {
    return {
      msg: t('result.blurry.msg'),
      description: t('result.blurry.description')
    }
  } else {
    return { msg: t('result.generic_erorr') }
  }
})

const getErrorMessage = () => {
  switch (props.codeStatus) {
    case 'auth_unknown':
      return {
        msg: t('result.generic_erorr')
      }
    case 'not_read':
      return {
        msg: t('result.unreadable.msg'),
        description: t('result.unreadable.description')
      }
    case 'bad_quality':
      return getQualityErrorMessage.value
  }
}

const toggleInstruction = () => {
  openInstructions.value = !openInstructions.value
}

const goHome = () => {
  events.value.goHome = true
}

const handleRetakePhoto = () => {
  events.value.triggerTakePicture = true
}

onMounted(() => {
  if (props.codeStatus !== 'bad_quality') {
    disableButton.value = true
  }
})
</script>
